// A selected free-brief offer behaves like a radio choice: selecting it again
// must not fall back to buying one individual brief without the free items.
const periodScope = (target) => {
  if (!(target instanceof Element)) return null;
  const scope = target.closest('.product-information');
  return scope?.querySelector('[data-launch-product="period"]') ? scope : null;
};

function keepSelectedBundle(event) {
  if (event.type !== 'click' && !['Enter', ' '].includes(event.key)) return;
  const scope = periodScope(event.target);
  if (!scope) return;
  const header = event.target.closest('.kaching-bundles__bar-main');
  if (!header?.closest('.kaching-bundles__bar--selected')) return;
  event.preventDefault();
  event.stopImmediatePropagation();
}

function requireBundle(event) {
  const scope = periodScope(event.target);
  if (!scope) return;
  if (event.type === 'click' && !event.target.closest('button[name="add"]')) return;
  const individualBrief = scope.querySelector('.variant-option--launch-offer input[value="1 Brief"]:checked');
  if (!individualBrief) return;
  const selected = scope.querySelector('kaching-bundles-block .kaching-bundles__bar--selected');
  const message = scope.querySelector('[data-sm-offer-error]');
  if (selected) {
    if (message) message.hidden = true;
    return;
  }
  event.preventDefault();
  event.stopImmediatePropagation();
  if (message) message.hidden = false;
  scope.querySelector('kaching-bundles-block .kaching-bundles__bar-main')?.focus();
}

for (const eventName of ['click', 'keydown', 'keyup']) {
  document.addEventListener(eventName, keepSelectedBundle, true);
}
document.addEventListener('click', requireBundle, true);
document.addEventListener('submit', requireBundle, true);
